import React, { useMemo } from "react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
import { SANITY_DATASET as dataset, SANITY_PROJECT_ID as projectId } from "utils/constants";
import Link from "helpers/link";
import clsx from "clsx/lite";

const getGatsbyImage = (img, width) => {
	return getGatsbyImageData(
		img,
		{ width: width || 2560 },
		{ projectId, dataset }
	);
};

const ImageContent = ({ image, alt, url, className, width, ...other }) => {
	const imageMemo = useMemo(() => {
		if (!image?.shopifyImage) {
			return getGatsbyImage(image, width);
		}
		return null;
	}, [image, width]);

	const imgAlt = alt ?? image?.alt ?? "";

	if (image?.shopifyImage?.url) {
		return (
			<img
				src={image.shopifyImage.url}
				alt={imgAlt}
				role="img"
				className={clsx("gatsby-image-wrapper gatsby-image-wrapper-constrained object-cover", !url && className)}
				{...(!url && other)}
			/>
		);
	} else if (imageMemo) {
		return (
			<GatsbyImage
				image={imageMemo}
				alt={imgAlt}
				className={clsx(!url && className)}
				role="img"
				data-attr="tag"
				{...(!url && other)}
			/>
		);
	}

	return null;
};

const Image = ({ image, width, className, alt, to, ...other }) => {
	if (!image?.asset && !image?._ref && !image?.shopifyImage) return null;

	const url = to || image?.url || "";

	const content = <>
		<ImageContent
			url={url}
			alt={(alt || image.caption || "image")}
			image={image}
			className={className}
			width={width}
			{...other}
		/>
		{image?.caption && (
			<p className="text-secondary-darker md:pt-0 lg:pt-2 text-center">
				{image.caption}
			</p>
		)}
	</>;

	if (!url) {
		return content;
	}

	return (
		<Link
			to={url}
			className={className}
			role="button"
			aria-label={alt ?? "link"}
			{...other}
		>
			{content}
		</Link>
	);
};

export default Image;